import { type ReactElement, useCallback, useState } from 'react'
import { useSnapshot } from 'valtio'
import format from 'date-fns/format'

import { recurringPaymentsProxy } from '../../../../recurringPaymentsProxy'
import { executeRetrieveRecurringPaymentsSearch } from '../../../../../../../../shared/apiUtils/executeRetrieveRecurringPaymentsSearch'
import DateIcon from './DateIcon'
import { ExpandedDatePicker } from './ExpandedDatePicker'

export function EndDateFilter (): ReactElement {
  const snap = useSnapshot(recurringPaymentsProxy)
  const [expanded, setExpanded] = useState(false)
  const closeExpanded = useCallback(() => { setExpanded(false) }, [setExpanded])

  const onClear = useCallback(() => {
    recurringPaymentsProxy.filters.endDate = null
    closeExpanded()
    void executeRetrieveRecurringPaymentsSearch({ displayLoader: false })
  }, [closeExpanded])

  const onChange = useCallback((date: Date) => {
    recurringPaymentsProxy.filters.endDate = date
    closeExpanded()
    void executeRetrieveRecurringPaymentsSearch({ displayLoader: false })
  }, [closeExpanded])

  return (
    <div className="relative">
      <button
        className="border border-gray-200 rounded hover:border-gray-300 relative"
        onClick={() => { setExpanded(!expanded) }}
      >
        <div
          className="bg-white h-10 px-5 text-sm rounded flex
                   items-center text-wpy-gray cursor-pointer"
          style={{ minWidth: '12rem' }}
        >
          To:&nbsp;
          <span className="font-semibold text-black tracking-widest ml-1">
            {snap.filters.endDate && format(snap.filters.endDate, 'MM/dd/yy')}
          </span>
        </div>
        <div className="absolute right-0 top-0 mt-2 mr-4">
          <DateIcon />
        </div>
      </button>
      {expanded && (
        <ExpandedDatePicker
          onClear={onClear}
          onChange={onChange}
          date={snap.filters.endDate}
          closeExpanded={closeExpanded}
        />
      )}
    </div>
  )
}
